import React from "react";
import CommonView, { CommonViewProps } from "../../../../components/CommonView/CommonView";
import FormTabs from "./FormTabs";
import { Space, Typography } from "antd";

const DoccumentSettings = () => {

    const comonConfig: CommonViewProps = {
        config: {
            api: () => '/doccument-folders',
            modalTitle: () => 'Doccument',
            getFormColumns: () => [
                {
                    label: 'Name',
                    name: 'name',
                    type: 'text',
                    span: 8,
                    rules: [{ required: true, message: 'Please enter DoccumentSettings' }]
                },
                {
                    span: 16
                },
                {
                    label: 'Description',
                    name: 'description',
                    type: 'textarea',
                    span: 8,
                }
            ]
        },
        componentConfig: {
            title: 'Doccument',
            subTitle: 'Doccument',
            cardTitle: 'Doccument',
            buttonName: 'Add Doccument',
            emptyDescription: 'Doccument',
            customHeading: (item) => <Space direction="vertical" size={0}>
                <Typography.Title level={4} style={{ margin: 0 }}>{item?.name}</Typography.Title>
                <Typography.Text type="secondary">{item?.description}</Typography.Text>
            </Space>,
            renderComponent: (record) => {
                return <FormTabs record={record} />
            },
            renderListItem: (record) => {
                return <div>{record?.name}</div>
            }
        },
        listProps: {
            height: 300,
        }
    }

    return <CommonView {...comonConfig} />

};


export default DoccumentSettings;    
